import { Token } from '@emberswap/emberswap-sdk2/dist/entities'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { ChainTokenMap } from '@emberswap/emberswap-sdk2/dist/types/token-lists'
import { useMemo } from 'react'

/** reduce token map into standard address <-> Token mapping, optionally include user added tokens
 * @param {ChainId | undefined}chainId
 * @param {ChainTokenMap} tokenMap
 * @return {Record<string, Token>}
 */
export function useTokensFromMap(
  chainId: ChainId | undefined,
  tokenMap: ChainTokenMap
): Record<string, Token> {
  return useMemo(() => {
    if (!chainId) return {}

    // reduce to just tokens
    const mapWithoutUrls = Object.keys(tokenMap[chainId] ?? {}).reduce<{
      [address: string]: Token
    }>((newMap, address) => {
      newMap[address] = tokenMap[chainId][address].token
      return newMap
    }, {})

    return mapWithoutUrls
  }, [chainId, tokenMap])
}
